import { useEffect, useState } from "react";
import Pagination from "../Config/Pagination";

import { API_BASE_URL } from "../Config/Config";
import Swal from "sweetalert2";
import { Select } from "antd";
import { FooterComponent } from "../Config/footer";
import { HeaderComponent } from "../Config/header";
import { Link, useNavigate } from "react-router-dom";

export function LeavesComponent() {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [storedUserData, setStoredUserData] = useState([]);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [status, setStatus] = useState("all");
  const [dataLoading, setDataLoading] = useState(false);
  const [leavesData, setLeavesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  // const [halfDay, setHalfDay] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [comments, setComments] = useState("");
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [leaveCategory, setLeaveCategory] = useState("");
  const [selectedLeaveType, setSelectedLeaveType] = useState(null);

  const [tokenData, setTokenData] = useState(null);
  useEffect(() => {
    const token =
      localStorage.getItem("authToken") || sessionStorage.getItem("authToken");

    if (token) {
      setTokenData(token);
    } else {
      console.warn("User data not found ");
      navigate("/");
    }
  }, [navigate]);

  const currentYear = new Date().getFullYear();

  const yearOptions = Array.from({ length: 4 }, (_, i) => {
    const y = currentYear - i;
    return { value: String(y), label: String(y) };
  });

  const leaveTypeOptions = leaveTypes.map((leaveType) => ({
    value: leaveType.Id,
    label: leaveType.LvType,
  }));

  const statusOptions = [
    { value: "1", label: "Pending" },
    { value: "2", label: "Approved" },
    { value: "3", label: "Rejected" },
  ];

  const currentItems = leavesData.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    const userDataString =
      localStorage.getItem("userData") || sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setStoredUserData(userData);
    } else {
      console.log("User data not found");
    }
  }, []);

  const fetchData = async () => {
    if (storedUserData?.RegId) {
      setDataLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}leave/getempleaves?regid=${storedUserData.RegId}&superid=${storedUserData.SuperId}&&year=${year}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${tokenData}` },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setLeavesData(data["ResultData"]);
        } else {
          console.error("Failed to fetch leaves data:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching leaves data:", error.message);
      } finally {
        setDataLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [storedUserData?.RegId, year]);

  const handleLeaveTypeChange = (selectedOption) => {
    setSelectedLeaveType(selectedOption);
    if (selectedOption) {
      setLeaveCategory(selectedOption.value);
    }
  };

  const calculateLeaveCount = (startDate, endDate, halfDay) => {
    const startDateObj = new Date(startDate);
    const endDateObj = new Date(endDate);
    const timeDifference = endDateObj - startDateObj;
    const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

    let leaveCount = 0;

    if (startDate === endDate && halfDay) {
      leaveCount = 0.5;
    } else if (startDate === endDate) {
      leaveCount = 1;
    } else {
      if (halfDay) {
        leaveCount = daysDifference + 0.5;
      } else {
        leaveCount = daysDifference;
      }
    }
    return leaveCount;
  };

  useEffect(() => {
    if (storedUserData && storedUserData.SuperId) {
      const fetchLeaveTypes = async () => {
        try {
          const response = await fetch(`${API_BASE_URL}leave/getleavetype`, {
            method: "GET",
            headers: { Authorization: `Bearer ${tokenData}` },
          });
          const data = await response.json();
          setLeaveTypes(data["ResultData"]);
        } catch (error) {
          console.error("Error fetching leave types:", error);
        }
      };
      fetchLeaveTypes();
    }
  }, [storedUserData && storedUserData.SuperId]);

  const handleLeaveSubmit = async (e) => {
    e.preventDefault();
    const start = new Date(startDate);
    const end = new Date(endDate);

    let leaveCount = Math.ceil((end - start) / (1000 * 3600 * 24)) + 1;

    // Subtract 0.5 if halfDay is selected
    // leaveCount -= halfDay ? 0.5 : 0;

    // Now validate the fields
    if (!startDate || !endDate || !comments || !selectedLeaveType) {
      alert("Select required fields.");
    } else {
      setLoading(true);
      const leaveData = {
        apptype: storedUserData.apptype,
        inputdata: {
          superid: storedUserData.SuperId,
          regid: storedUserData.RegId,
          lvtypeid: selectedLeaveType,
          startdate: startDate,
          enddate: endDate,
          leavecount: leaveCount,
          comments: comments,
          halfday: 0,
        },
      };

      try {
        console.log("checking try");

        const response = await fetch(`${API_BASE_URL}leave/saveleave`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify({ inputdata: leaveData["inputdata"] }),
        });

        const result = await response.json();
        if (result.status) {
          Swal.fire({
            title: "Success",
            text: `Leave Applied Successfully`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            title: "Error",
            text: `Filad to apply Leave`,
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Error submitting leave:", error);
      }
    }
  };

  const formatDateDDMMYYYY = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
  };
  return (
    <>
      <HeaderComponent></HeaderComponent>
      <div className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <div
            className="wrapper d-flex flex-column flex-row-fluid"
            id="kt_wrapper"
          >
            <div className="toolbar  " id="kt_toolbar">
              <div
                id="kt_toolbar_container"
                className="app-container container-xxl d-flex flex-stack flex-wrap p-3"
              >
                <div className="page-title d-flex flex-column">
                  <h1 className="page-heading d-flex flex-column justify-content-center text-gray-900 fw-bolder fs-3 m-2">
                    Leaves
                  </h1>
                </div>
                <div className={`${showOffcanvas ? "show" : ""}`}>
                  <Link
                    className="btn btn-flex flex-center btn-primary align-self-center px-0 px-md-3 h-30px w-30px w-md-auto h-lg-40px ms-1 ms-lg-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#applyLeaveOffCanvas"
                    aria-controls="applyLeaveOffCanvas"
                    onClick={() => setShowOffcanvas(true)}
                  >
                    <i className="fa-solid fa-plus"></i>
                  </Link>

                  {/* Off-canvas component */}
                  <div
                    className="offcanvas offcanvas-start"
                    tabIndex="-1"
                    id="applyLeaveOffCanvas"
                    aria-labelledby="offcanvasExampleLabel"
                  >
                    <div className="offcanvas-header bg-secondary">
                      <h5
                        className="offcanvas-title"
                        id="offcanvasExampleLabel"
                      >
                        Apply Leave
                      </h5>
                      <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        onClick={() => setShowOffcanvas(false)}
                      ></button>
                    </div>
                    <div className="offcanvas-body p-0">
                      <form className="row p-7" onSubmit={handleLeaveSubmit}>
                        <div className="col-6 d-flex flex-column dropdown mt-3 ">
                          <label
                            htmlFor="gender"
                            className="required form-label mb-3 text-start"
                          >
                            Type
                          </label>
                          <Select
                            style={{ width: 160 }}
                            placeholder="Choose Type"
                            options={leaveTypeOptions}
                            value={selectedLeaveType}
                            onChange={handleLeaveTypeChange}
                          />
                        </div>

                        {/* <div className="col-6 d-flex flex-column dropdown mt-3">
                          <label
                            htmlFor="halfDayLeave"
                            className="required form-label mb-3 text-start"
                          >
                            Half Day Leave
                          </label>
                          <input
                            type="checkbox"
                            id="halfDayCheckbox"
                            name="half_day_leave"
                            className="form-check-input"
                            checked={halfDay}
                            onChange={(e) => setHalfDay(e.target.checked)}
                          />
                        </div> */}

                        <div className="col-6 d-flex flex-column dropdown mt-3">
                          <label
                            htmlFor="date"
                            className="required form-label mb-3 text-start"
                          >
                            Start Date
                          </label>
                          <input
                            type="date"
                            style={{ width: 160 }}
                            className="form-control form-control-sm form-control-solid"
                            placeholder=""
                            id="date"
                            name="startDate"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            required
                          />
                        </div>

                        <div className="col-6 d-flex flex-column dropdown mt-3 text-start">
                          <label
                            htmlFor="date"
                            className="required form-label mb-3 text-start"
                          >
                            End Date
                          </label>
                          <input
                            type="date"
                            style={{ width: 160 }}
                            className="form-control form-control-sm form-control-solid text-align-start"
                            placeholder=""
                            id="date"
                            name="endDate"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                        </div>
                        <div className="col-12 mb-5 fv-row">
                          <label
                            htmlFor="address"
                            className="required form-label mb-3 text-start"
                          >
                            Reason
                          </label>

                          <textarea
                            required
                            className="form-control form-control-sm form-control-solid"
                            placeholder=""
                            id="address"
                            name="address"
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                          />
                        </div>

                        <div className="col-6 col-lg-3 mt-10 mx-2 w-100px">
                          <button
                            type="submit"
                            className="btn btn-primary h-35px h-lg-33px me-2"
                            aria-label="Close"
                            style={{
                              marginTop: "10px",
                              paddingTop: "5px",
                              paddingBottom: "5px",
                            }}
                          >
                            {loading ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start container-xxl"
              style={{ marginBottom: "100px" }}
            >
              <div className="content flex-row-fluid pt-1" id="kt_content">
                <div className="card">
                  {/* <div className="row justify-content-around d-flex my-2 container-fluid ">
                    <div
                      className="border border-gray-300 rounded col-3 mb-2"
                      style={{ backgroundColor: "#f17bb5" }}
                    >
                      <div className="row">
                        <div className="col-3 py-2 text-start">
                          <i className="fa-regular fa-hourglass-half fa-xl text-white"></i>
                        </div>
                        <div
                          className="fs-4 fw-bold col-9 text-start pt-1 text-white"
                          data-kt-countup="true"
                        >
                          10
                        </div>
                        <div className="fw-semibold fs-6  col-12 text-center p-0 text-white">
                          Pending
                        </div>
                      </div>
                    </div>
                    <div
                      className="border border-gray-300 rounded col-3 mb-2"
                      style={{ backgroundColor: "#ffa269" }}
                    >
                      <div className="row">
                        <div className="col-3 py-2 text-start">
                          <i className="fa-solid fa-thumbs-up fa-xl  text-white"></i>
                        </div>
                        <div
                          className="fs-4 fw-bold col-9 text-start pt-1  text-white"
                          data-kt-countup="true"
                        >
                          10
                        </div>
                        <div className="fw-semibold fs-6 col-12 text-center p-0  text-white">
                          Approved
                        </div>
                      </div>
                    </div>
                    <div
                      className="border border-gray-300 rounded col-3 mb-2"
                      style={{ backgroundColor: "#a3cb82" }}
                    >
                      <div className="row">
                        <div className="col-3 py-2 text-start">
                          <i className="fa-solid fa-calendar-xmark fa-xl text-white"></i>
                        </div>
                        <div
                          className="fs-4 fw-bold col-9 text-start pt-1  text-white"
                          data-kt-countup="true"
                        >
                          10
                        </div>
                        <div
                          className="fw-semibold fs-6  col-12 text-center p-0  text-white"
                        >
                          Rejected
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className="d-flex justify-content-end p-3">
                    <Select
                      placeholder="Choose Year"
                      id="year"
                      optionFilterProp="label"
                      options={yearOptions}
                      value={year}
                      onChange={(selectedOption) => setYear(selectedOption)}
                      style={{ width: "100px" }}
                    ></Select>
                  </div>
                  <div className="card-body p-3">
                    <div className="table-responsive">
                      <div className="table align-middle table-row-dashed fs-6 gy-5">
                        <div className=" text-start sfw-semibold text-gray-600">
                          {dataLoading ? (
                            <div>
                              <div className="text-center" colSpan="12">
                                <p className="loader"> loading.....</p>
                              </div>
                            </div>
                          ) : currentItems.length === 0 ? (
                            <div>
                              <div className="text-center" colSpan="12">
                                No data available
                              </div>
                            </div>
                          ) : (
                            currentItems.map((item, index) => (
                              <div
                                className="card card border border-secondary mt-3"
                                key={index}
                              >
                                <div className="card-header d-flex justify-content-around align-items-center p-2 ">
                                  <div className="d-flex  align-items-center w-100 row">
                                    <div className=" my-1 col d-flex">
                                      <p className="m-0 text-muted fw-semibold">
                                        Start:
                                      </p>
                                      <p className="m-0 text-dark">
                                        {item.StartDt
                                          ? formatDateDDMMYYYY(item.StartDt)
                                          : "N/A"}
                                      </p>
                                    </div>
                                    <div className="my-1 col d-flex">
                                      <p className="m-0 text-muted fw-semibold ms-2">
                                        End:
                                      </p>
                                      <p className="m-0 text-dark">
                                        {item.EndDt
                                          ? formatDateDDMMYYYY(item.EndDt)
                                          : "N/A"}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="d-flex  align-items-center w-100 row">
                                    <div className=" my-1 col d-flex">
                                      <p className="m-0 text-muted fw-semibold ">
                                        Count:
                                      </p>
                                      <p className="m-0 text-dark">
                                        {item.LeaveCount
                                          ? item.LeaveCount
                                          : "N/A"}
                                      </p>
                                    </div>
                                    <div className="my-1 col d-flex">
                                      <p className="m-0 text-muted fw-semibold ms-2">
                                        Leave:
                                      </p>
                                      <p className="m-0 text-dark">
                                        {item.LvType ? item.LvType : "N/A"}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="card-body p-2 d-flex">
                                  <p className="m-0 text-muted fw-semibold ms-3 me-1">
                                    Comments:
                                  </p>
                                  <p className="text-dark">
                                    {item.Comments ? item.Comments : "N/A"}
                                  </p>
                                  {/* <p className="m-0">
                                  <strong>Comments:</strong> {item.Comments}
                                </p> */}
                                </div>
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                    <Pagination
                      itemsPerPage={itemsPerPage}
                      totalItems={leavesData.length}
                      paginate={paginate}
                      currentPage={currentPage}
                    />
                  </div>
                  <div
                    className="offcanvas offcanvas-end"
                    tabIndex="-1"
                    id="offcoffcanvasExampleanvasExample"
                    aria-labelledby="offcanvasExampleLabel"
                    style={{ width: "500px" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterComponent></FooterComponent>
    </>
  );
}
